import { priceMonitoring } from './monitoring.js';
export function priceEstimate(inputs, book) {
    if (inputs.offerType !== book.offerType) {
        throw new Error(`Offer type mismatch: inputs '${inputs.offerType}', price book '${book.offerType}'`);
    }
    return priceMonitoring(inputs, book);
}
//# sourceMappingURL=price.js.map